import { jsonApi } from '../http-request';

export const actions = jsonApi.createUpdResourceFacade('phone_verifications');

const REQUEST_PIN = 'request_pin';
actions.requestPin = body => actions.action(REQUEST_PIN, body);
actions.isRequestPin = actions.isAction(REQUEST_PIN);
